import {
  Target,
  Building,
  BookOpen,
  Newspaper,
  FileText,
  User,
} from "lucide-react";
import { GitHubIcon } from "@/components/Chat/header/icons/GitHubIcon";
import { LinkedInIcon } from "@/components/Chat/header/icons/LinkedInIcon";

/**
 * Icon mapping for web search focus options
 */
export const FOCUS_ICON_MAP = {
  auto: Target,
  company: Building,
  research: BookOpen,
  news: Newspaper,
  pdf: FileText,
  github: GitHubIcon,
  personal: User,
  linkedin: LinkedInIcon,
};

/**
 * Default English translations for web search focus options
 * Used as fallbacks when i18n is not available
 */
export const WEB_SEARCH_FOCUS_TRANSLATIONS = {
  "webSearchFocus.auto.name": "Auto",
  "webSearchFocus.auto.description": "Let AI automatically determine the best search approach",
  "webSearchFocus.company.name": "Company",
  "webSearchFocus.company.description": "Focus on company websites and business information",
  "webSearchFocus.research.name": "Research",
  "webSearchFocus.research.description": "Academic papers, research articles, and scholarly content",
  "webSearchFocus.news.name": "News",
  "webSearchFocus.news.description": "Recent news articles and current events",
  "webSearchFocus.pdf.name": "PDF",
  "webSearchFocus.pdf.description": "PDF documents and reports",
  "webSearchFocus.github.name": "GitHub",
  "webSearchFocus.github.description": "GitHub repositories and code-related content",
  "webSearchFocus.personal.name": "Personal Sites",
  "webSearchFocus.personal.description": "Personal blogs, portfolios, and individual websites",
  "webSearchFocus.linkedin.name": "LinkedIn",
  "webSearchFocus.linkedin.description": "LinkedIn profiles and professional content",
};

/**
 * Web search focus options configuration
 * Each option has:
 * - id: unique identifier sent to API
 * - nameKey: i18n key for display name
 * - descriptionKey: i18n key for description/tooltip
 * - icon: key to lookup in FOCUS_ICON_MAP
 */
export const WEB_SEARCH_FOCUS_OPTIONS = [
  {
    id: "auto",
    nameKey: "webSearchFocus.auto.name",
    descriptionKey: "webSearchFocus.auto.description",
    icon: "auto",
  },
  {
    id: "company",
    nameKey: "webSearchFocus.company.name",
    descriptionKey: "webSearchFocus.company.description",
    icon: "company",
  },
  {
    id: "research",
    nameKey: "webSearchFocus.research.name",
    descriptionKey: "webSearchFocus.research.description",
    icon: "research",
  },
  {
    id: "news",
    nameKey: "webSearchFocus.news.name",
    descriptionKey: "webSearchFocus.news.description",
    icon: "news",
  },
  {
    id: "pdf",
    nameKey: "webSearchFocus.pdf.name",
    descriptionKey: "webSearchFocus.pdf.description",
    icon: "pdf",
  },
  {
    id: "github",
    nameKey: "webSearchFocus.github.name",
    descriptionKey: "webSearchFocus.github.description",
    icon: "github",
  },
  {
    id: "personal",
    nameKey: "webSearchFocus.personal.name",
    descriptionKey: "webSearchFocus.personal.description",
    icon: "personal",
  },
  {
    id: "linkedin",
    nameKey: "webSearchFocus.linkedin.name",
    descriptionKey: "webSearchFocus.linkedin.description",
    icon: "linkedin",
  },
];
